import { API } from "./api";

export function brl(n) {
  const v = Number(n || 0);
  return v.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

export function mediaUrl(v) {
  if (!v) return null;
  if (typeof v !== "string") return null;
  if (v.startsWith("http") || v.startsWith("blob:") || v.startsWith("data:")) return v;
  return `${API}/files/${v}`;
}

export function discountPct(price, promo) {
  if (!promo || !price || promo >= price) return 0;
  return Math.round(((price - promo) / price) * 100);
}

const DAYS = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];

// Normalize a day config (old {open,close,closed} or new {closed,intervals})
// into a list of {open,close} intervals. Empty when closed/invalid.
export function dayIntervals(day) {
  if (!day || day.closed) return [];
  if (Array.isArray(day.intervals)) return day.intervals.filter((i) => i.open && i.close);
  if (day.open && day.close) return [{ open: day.open, close: day.close }];
  return [];
}

function withinInterval(iv, cur) {
  const [oh, om] = iv.open.split(":").map(Number);
  const [ch, cm] = iv.close.split(":").map(Number);
  const o = oh * 60 + om;
  let c = ch * 60 + cm;
  if (c <= o) { c += 24 * 60; const cc = cur >= o ? cur : cur + 24 * 60; return cc >= o && cc <= c; }
  return cur >= o && cur <= c;
}

export function isOpenNow(hours) {
  if (!hours) return false;
  const now = new Date();
  const cur = now.getHours() * 60 + now.getMinutes();
  const todayKey = DAYS[now.getDay()];
  const ydayKey = DAYS[(now.getDay() + 6) % 7];
  for (const iv of dayIntervals(hours[todayKey])) if (withinInterval(iv, cur)) return true;
  // yesterday's interval that crosses midnight, now in the early hours
  for (const iv of dayIntervals(hours[ydayKey])) {
    const [oh, om] = iv.open.split(":").map(Number);
    const [ch, cm] = iv.close.split(":").map(Number);
    if ((ch * 60 + cm) <= (oh * 60 + om) && cur <= (ch * 60 + cm)) return true;
  }
  return false;
}

export const DAY_LABELS = {
  mon: "Segunda", tue: "Terça", wed: "Quarta", thu: "Quinta",
  fri: "Sexta", sat: "Sábado", sun: "Domingo",
};
export const DAY_ORDER = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];

// Strip a leading Brazilian country code (55) when the number is long enough
// to actually include it, returning the local DDD + number (max 11 digits).
export function localDigitsBR(v) {
  let d = (v || "").replace(/\D/g, "");
  if (d.length >= 12 && d.startsWith("55")) d = d.slice(2);
  return d.slice(0, 11);
}

export function maskPhoneBR(v) {
  const d = localDigitsBR(v);
  if (d.length <= 2) return d;
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
}

// Build a wa.me number: local BR number prefixed with 55, avoiding a double 55.
export function waNumber(v) {
  const d = (v || "").replace(/\D/g, "");
  if (d.length >= 12 && d.startsWith("55")) return d;
  return `55${d}`;
}

export function slugify(v) {
  return (v || "").normalize("NFKD").replace(/[\u0300-\u036f]/g, "").toLowerCase()
    .replace(/[^a-z0-9]+/g, "-").replace(/-{2,}/g, "-").replace(/^-|-$/g, "");
}

export const BADGES = {
  mais_vendido: { label: "Mais vendido", cls: "bg-orange-500 text-white" },
  top: { label: "Top", cls: "bg-orange-500 text-white" },
  promo: { label: "Promo", cls: "bg-rose-600 text-white" },
  novo: { label: "Novo", cls: "bg-emerald-500 text-white" },
  classico: { label: "Clássico", cls: "bg-zinc-700 text-white" },
  esgotado: { label: "Esgotado", cls: "bg-zinc-800 text-zinc-400" },
};
